import ReactDOM from 'react-dom/client';
import React from "react";
import App from './components/App';
import { BrowserRouter } from 'react-router-dom';
import './assets/styles/index.scss';
import { StoreProvider } from 'providers/StoreProvider';
import './i18n/config';
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";


Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    replaysSessionSampleRate: 0.1, // 10% of sessions will be replayed
    replaysOnErrorSampleRate: process.env.NODE_ENV === "production" ? 1.0 : 0.1, // 100% of errors will be replayed
  });
  
  import("@sentry/react").then((lazyLoadedSentry) => {
    if (lazyLoadedSentry.replayIntegration) {
      Sentry.addIntegration(lazyLoadedSentry.replayIntegration());
    }
  });

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <BrowserRouter>
        <StoreProvider>
            <App />
        </StoreProvider>
    </BrowserRouter>
);